import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl mt-0 font-bold" }, "Beteiligte", -1)
const _hoisted_3 = {
  key: 1,
  class: "mt-4"
}

import { SwiperSlide } from 'swiper/vue';
import DynamicSwiper from '@/components/dynamicSwiper.vue'
import SwiperDiv from '@/components/DetailPage/SwiperDiv.vue'
import { useSelectedProject } from '@/store/selectedProject'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubcustomerData',
  setup(__props) {

const selectedProjectStore = useSelectedProject()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(selectedProjectStore).subcustomers && _unref(selectedProjectStore).subcustomers.length > 0)
      ? (_openBlock(), _createBlock(DynamicSwiper, {
          key: 0,
          pagination: true,
          "class-swiper": "h-full w-full mt-4"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedProjectStore).subcustomers, (subcustomer, index) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                default: _withCtx(() => [
                  _createVNode(SwiperDiv, {
                    "title-start": subcustomer.function.name,
                    "title-end": subcustomer.name,
                    city: subcustomer.zip + ' ' + subcustomer.city,
                    address: subcustomer.street + ' ' + subcustomer.no,
                    phone: subcustomer.phone,
                    "mobile-phone": subcustomer.mobile,
                    email: subcustomer.email,
                    fax: subcustomer.fax
                  }, null, 8, ["title-start", "title-end", "city", "address", "phone", "mobile-phone", "email", "fax"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("p", _hoisted_3, "Keine Beteiligte für dieses Projekt gefunden"))
  ]))
}
}

})